import axios from "@/plugins/axios.js"
import api from "@/api.js"
import {
	buildPieEventsDataPayload,
	buildPieEventsPreviewPayload,
} from "@/services/dashboard-pie-events.config.js"

const PIE_EVENTS_BASE_PATH = "/api/v1/dashboard/charts/pie/events";

export default new class DashboardChartsService{
	constructor(){
		this.basePath = PIE_EVENTS_BASE_PATH;
	}

	getUrl(path){
		if (!api) return null;
		return `${api.url}${this.basePath}${path}`;
	}

	async getPieEventsMetadata(){
		try{
			const uri = this.getUrl("/metadata");
			if (uri) {
				const data = await axios.get(uri);
				return data;
			}
		}catch(er){
			console.warn("Error get pie events metadata ", er)
			return er;
		}
		return null;
	}

	async previewPieEvents(config){
		try{
			const uri = this.getUrl("/preview");
			if (uri) {
				const payload = buildPieEventsPreviewPayload(config);
				const data = await axios.post(uri, payload);
				return data;
			}
		}catch(er){
			console.warn("Error preview pie events ", er)
			return er;
		}
		return null;
	}

	async getPieEventsData(streamData){
		try{
			const uri = this.getUrl("/data");
			if (uri) {
				const payload = buildPieEventsDataPayload(streamData);
				const data = await axios.post(uri, payload);
				return data;
			}
		}catch(er){
			console.warn("Error get pie events data ", er)
			return er;
		}
		return null;
	}
}

export {
	PIE_EVENTS_BASE_PATH,
};
